import React, { ReactChild } from 'react'
import { configDilemas, PreArgConfig, Argumento } from '../data'

export type AppContextData = {
  datetime: string
  visited: Array<string>
  experiment: Experiment
  regressors?: Regressors
}

export type DilemaOpinion = {
  id_dilema: number // id
  pre_aceptabilidad: number
  pre_confianza: number
  argumentos: number[] // ids
  post_aceptabilidad: number
  post_confianza: number
  acuerdo_argumentos: ValoracionArgumento[]
}

export type PrimeraFaseData = {
  orden_dilemas: number[] // ids
  datas: DilemaOpinion[]
}

export type ValoracionArgumento = {
  argument_id: number // id
  acuerdo: string
}

type Regressors = {
  edad: number | string
  genero: string
  nivel_educativo: string
  humildad_1: string
  humildad_2: string
  humildad_3: string
  humildad_4: string
  humildad_5: string
  humildad_6: string
  humildad_7: string
  humildad_8: string
  humildad_9: string
  humildad_10: string
  orden: string[]
}

export type Experiment = {
  argumentos: Argumento[]
  config: PreArgConfig[]
  fase_1?: PrimeraFaseData
}

const initialAppContextData: () => AppContextData = () => {
  return {
    datetime: new Date().toLocaleString('es', { hour12: false }),
    visited: [],
    experiment: {
      argumentos: [],
      config: configDilemas(),
    },
  }
}

type Visit = {
  type: 'REGISTER_VISIT'
  route: string
}

type AcceptTerms = {
  type: 'ACCEPT_TERMS'
}

type SaveRegressors = {
  type: 'SAVE_REGRESSORS'
  data: Regressors
}

type SavePrimeraFase = {
  type: 'SAVE_FASE_1'
  data: PrimeraFaseData
}

type ReducerAction = AcceptTerms | Visit | SavePrimeraFase | SaveRegressors

function reducer(state: AppContextData, action: ReducerAction): AppContextData {
  switch (action.type) {
    case 'REGISTER_VISIT': {
      return {
        ...state,
        visited: [...state.visited, action.route],
      }
    }
    case 'ACCEPT_TERMS': {
      return {
        ...state,
      }
    }
    case 'SAVE_REGRESSORS': {
      const { data } = action
      return {
        ...state,
        regressors: data,
      }
    }
    case 'SAVE_FASE_1': {
      const { data } = action
      return {
        ...state,
        experiment: {
          ...state.experiment,
          fase_1: data,
        },
      }
    }
  }
}

export const AppContext = React.createContext({
  appState: initialAppContextData(),
  dispatch: (value: ReducerAction) => {},
})

export function AppContextProvider(props: { children: ReactChild }) {
  const [state, dispatch] = React.useReducer(reducer, initialAppContextData())

  return (
    <AppContext.Provider value={{ appState: state, dispatch }}>
      {props.children}
    </AppContext.Provider>
  )
}
